import { useMemo } from "react";

import { useLocation } from "react-router-dom";

import SearchParams from "simplydo/core/searchParams";
import { Container, Divider, Tab } from "simplydo/react/ui";

import AppStyledDashboard from "components/AppStyledDashboard";
import { InvitationList } from "components/lib/Invitations/InvitationList";

import { Invitation } from "./Invitation";

const Invitations = () => {
  const location = useLocation();
  const params = useMemo(
    () => new SearchParams(location.search),
    [location.search],
  );
  const token = useMemo(() => params.get("invite_token"), [params]);
  if (token)
    return <AppStyledDashboard excludeWelcomeText content={<Invitation />} />;
  return (
    <div style={{ marginTop: 20 }}>
      <Container>
        <h1 style={{ color: "#3b3b3b", margin: 0 }}>Invitations</h1>
      </Container>
      <Divider hidden />
      <Container>
        <Tab
          menu={{ secondary: true, pointing: true }}
          panes={[
            { menuItem: "Invitations", render: () => <InvitationList /> },
            {
              menuItem: "Sent by you",
              render: () => <InvitationList createdBySelf={true} />,
            },
            {
              menuItem: "Previously accepted",
              render: () => <InvitationList accepted={true} />,
            },
          ]}
        />
      </Container>
    </div>
  );
};
export default Invitations;
